import { Clock, Flag, MapPin } from "feather-icons-react"
import Section, { parseColors } from "../Section"
import styles from "./Jobs.module.scss"

import LinkButton from "components/ui/LinkButton"
import colors from "tailwindcss/colors"

const Jobs = (params) => {
  const { data = {}, colors } = params
  const { isLightBackground } = parseColors({ colors })

  const { ankerslug, job_entries } = data

  if (job_entries?.length === 0) return null

  return (
    <Section
      id={ankerslug}
      sectionSpacing={{
        top: data?.section_padding_top?.value || null,
        bottom: data?.section_padding_bottom?.value || null,
      }}
      containerClassName={styles.jobs}
      colors={colors}
    >
      {job_entries.map((job, i) => (
        <JobTeaser key={i} job={job} isDark={isLightBackground} />
      ))}
    </Section>
  )
}

const JobTeaser = ({ job, isDark }) => {
  const backgroundColor = isDark ? colors.neutral[900] : colors.white

  const textColor = isDark ? "text-white" : "text-black"

  return (
    <div style={{ backgroundColor }} className={styles.jobTeaser}>
      <div className={styles.jobTeaserInner}>
        <span className={styles.jobBU}>{job.business_unit}</span>
        <h2 className={`${styles.jobHeadline} ${textColor}`}>{job.title}</h2>
        <p className={`${styles.jobText} ${textColor}`}>{job.teaser_text}</p>

        {/* Metadata Row with Icons */}
        <div className={`${styles.jobMetaWrapper} ${textColor}`}>
          {job.worktype?.label && (
            <div className={styles.jobMeta}>
              <MapPin className={styles.jobMetaIcon} />
              <span>{job.worktype.label}</span>
            </div>
          )}
          {job.arrangement?.length > 0 && (
            <div className={styles.jobMeta}>
              <Clock className={styles.jobMetaIcon} />
              <span>{job.arrangement.map((a) => a.label).join(" / ")}</span>
            </div>
          )}
          {job.workplaces?.length > 0 && (
            <div className={styles.jobMeta}>
              <Flag className={styles.jobMetaIcon} />
              <span>{job.workplaces.map((wp) => wp.label).join(" / ")}</span>
            </div>
          )}
        </div>
      </div>

      <div className={styles.jobButtonWrapper}>
        <LinkButton
          data={{ link_url: job.uri, link_text: "Details" }}
          className={!isDark && "invert"}
        />
      </div>
    </div>
  )
}

export default Jobs
